import { RING_DURATION_S, formatTime, type Command, type CommandType } from '@findmy/shared';

/** One line describing where a command has got to, in plain words. */
export function describeCommand(command: Command): string {
  const at = command.completedAt ? ` (${formatTime(command.completedAt)})` : '';
  const waiting =
    command.status === 'pending' ? 'Waiting for the device to connect…' : 'Sent. Waiting for the device…';
  const done: Record<CommandType, string> = {
    ring: `Ringing for ${RING_DURATION_S} seconds${at}`,
    locate_now: `Located${at}`,
    lost_mode_on: `Lost message showing on the device${at}`,
    lost_mode_off: `Lost mode turned off on the device${at}`,
  };
  const label: Record<CommandType, string> = {
    ring: 'Ring',
    locate_now: 'Locate now',
    lost_mode_on: 'Lost mode',
    lost_mode_off: 'Turning off lost mode',
  };
  switch (command.status) {
    case 'pending':
    case 'delivered':
      return `${label[command.type]}: ${waiting}`;
    case 'done':
      return done[command.type];
    case 'failed':
      return `${label[command.type]} failed: ${command.error ?? 'the device reported a problem'}`;
    case 'expired':
      return `${label[command.type]}: ${command.error ?? 'expired'}`;
  }
}
